export default {
  GET_MORE_CAFE_COMMENT_LOADING: 'GET_MORE_CAFE_COMMENT_LOADING',
  GET_MORE_CAFE_COMMENT_SUCCESS: 'GET_MORE_CAFE_COMMENT_SUCCESS',
  GET_MORE_CAFE_COMMENT_FAILED: 'GET_MORE_CAFE_COMMENT_FAILED',
  GET_MORE_CAFE_COMMENT_REJECT: 'GET_MORE_CAFE_COMMENT_REJECT',

  GET_MY_COMMENTS_LOADING: 'GET_MY_COMMENTS_LOADING',
  GET_MY_COMMENTS_SUCCESS: 'GET_MY_COMMENTS_SUCCESS',
  GET_MY_COMMENTS_FAILED: 'GET_MY_COMMENTS_FAILED',
  GET_MY_COMMENTS_REJECT: 'GET_MY_COMMENTS_REJECT',

  POST_NEW_COMMENT_LOADING: 'POST_NEW_COMMENT_LOADING',
  POST_NEW_COMMENT_SUCCESS: 'POST_NEW_COMMENT_SUCCESS',
  POST_NEW_COMMENT_FAILED: 'POST_NEW_COMMENT_FAILED',
  POST_NEW_COMMENT_REJECT: 'POST_NEW_COMMENT_REJECT',

  GET_CAFE_SUITABLE_FOR_LIST_LOADING: 'GET_CAFE_SUITABLE_FOR_LIST_LOADING',
  GET_CAFE_SUITABLE_FOR_LIST_SUCCESS: 'GET_CAFE_SUITABLE_FOR_LIST_SUCCESS',
  GET_CAFE_SUITABLE_FOR_LIST_FAILED: 'GET_CAFE_SUITABLE_FOR_LIST_FAILED',
  GET_CAFE_SUITABLE_FOR_LIST_REJECT: 'GET_CAFE_SUITABLE_FOR_LIST_REJECT',
};
